import React from "react";
import PerceptualMapChart from "./charts/perceptual-map";
import HelpIconButtonWithTooltipAndTypeformModal from "../../../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../../../typeform/TypeformContent";

function PerceptualMap(props) {
  const style = {
    color: "#f00",
    fontWeight: "bold",
    fontSize: "12px",
    marginLeft: "10px"
  };

  return (
    <div className="row m-0">
      <div className="bg-white p-30">
        <h5>
          PERCEPTUAL MAP
          <HelpIconButtonWithTooltipAndTypeformModal
            iconSize="sm"
            {...TypeformContent.PERCEPTUAL_MAP}
          />
          <span style={style}>Not available at this time</span>
        </h5>
        <hr />
        <div className="mt-30">
          <PerceptualMapChart />
        </div>
      </div>
    </div>
  );
}

export default PerceptualMap;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/perceptual-map.js